import Chart from 'react-apexcharts';
import React, { Component, Fragment } from 'react';
import { Card, CardContent, Tooltip } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import exportOptions from '../chartExportOptions';
const info = <HelpOutline style={{ fontSize: 15 }}/>;

class UsageComponent extends Component {

  render() {

    if (!this.props.series)
      return null;


    const legend = { 
      itemMargin: {
        horizontal: 0,
        vertical: 0
      },
      formatter: function(seriesName, opts) {
        const maxLength = 20;
        if(seriesName && seriesName.length > maxLength)
          return seriesName.substring(0, maxLength) + "...";
        return seriesName;
      },
    }

    const commonConfig = {
      chart: { animations: { enabled: false }, toolbar: { show: false }, ...exportOptions("Date", "Count") },
      dataLabels: { enabled: false },
      xaxis: { type: "datetime", labels: { show: true }, crosshairs: { width: 1 } },
      yaxis: { labels: { formatter: this.props.formatter ? this.props.formatter : function (val) { return val ? (val).toFixed(0) : ""; }, } },
      legend: { ...legend, position: "right", show: true },
      theme: { mode: 'light', palette: 'palette2', },
      markers: { size: 5, strokeColors: '#fff', strokeWidth: 1, shape: "circle", radius: 4, },
      tooltip: {shared: false, intersect: true}
    };

    if(this.props.annotations)
      commonConfig.annotations = this.props.annotations;

    return (
      <Fragment >
        <Card className="card-box mb-4">
          <CardContent style={{width:"100%"}}>
            <div className="d-flex align-items-start">
              { 
                this.props.tooltip ? 
                  <Tooltip title={this.props.tooltip }>
                    <div className="font-weight-bold mr-3">{this.props.title} {info}</div>
                  </Tooltip>
                :
                  <div className="font-weight-bold mr-3">{this.props.title}</div>
              }
            </div>
            <Chart options={commonConfig} series={this.props.series} type="line" height="200"/>
          </CardContent>
         </Card>
        </Fragment>
    ); // end of return

  } // end of render()

} // end of class

export default UsageComponent
